import { IElementType } from "core-integration/src/store/element-types/types";
import { IElement } from "core-integration/src/store/elements/types";
import { ITeam } from "core-integration/src/store/teams/types";
import { integerToMoney, isMoneyStat } from "core-integration/src/utils/money";
import { rgba } from "polished";
import * as React from "react";
import styled, { css } from "styled-components";
import ElementDialogButton from "./ElementDialogButton";
import ElementInTable from "./ElementInTable";
import { ElementCell, ElementRow } from "./ElementTable";

const StyledElementListRow = styled(ElementRow)<IStyledProps>`
  ${(props) =>
    props.isProposed &&
    css`
      td,
      button {
        color: ${rgba("black", 0.6)};
      }

      img {
        opacity: 0.6;
      }
    `}
`;

const ElementListStatCell = styled.td`
  font-weight: bold;
`;

interface IStyledProps {
  isProposed: boolean;
}

interface IProps extends IStyledProps {
  currencyDivisor: number;
  element: IElement;
  elementType: IElementType;
  renderElementDialog: () => void;
  renderElementMenu: () => void;
  sort: string | number;
  team: ITeam;
}

const ElementListRow: React.FC<IProps> = ({
  currencyDivisor,
  element,
  elementType,
  isProposed,
  renderElementMenu,
  sort,
  team,
}) => (
  <StyledElementListRow isProposed={isProposed}>
    <td>
      <ElementDialogButton elementId={element.id} variant="list" />
    </td>
    <ElementCell>
      <ElementInTable
        renderElementMenu={renderElementMenu}
        element={element}
        elementType={elementType}
        team={team}
      />
    </ElementCell>
    <ElementListStatCell>
      {integerToMoney(element.now_cost, currencyDivisor)}
    </ElementListStatCell>
    <ElementListStatCell>
      {isMoneyStat(sort)
        ? integerToMoney(element[sort] as number, currencyDivisor)
        : element[sort]}
    </ElementListStatCell>
  </StyledElementListRow>
);

export default ElementListRow;
